import type { ReactNode } from "react";

import { Link } from "@/i18n/navigation";
import { cn } from "@/lib/utils";

interface SettingsRowProps {
  children: ReactNode;
  href?: string;
  onClick?: () => void;
  className?: string;
}

export function SettingsRow({ children, href, onClick, className }: SettingsRowProps) {
  const shared = cn(
    "flex w-full min-h-20 items-center gap-4 px-4 transition-colors hover:bg-muted/60",
    className
  );

  if (href) {
    return (
      <Link href={href} className={shared}>
        {children}
      </Link>
    );
  }

  return (
    <button type="button" onClick={onClick} className={shared}>
      {children}
    </button>
  );
}
